import { connect } from 'react-redux';

import { toastr } from 'react-redux-toastr';
import BaseProductList from './base/base-product-list';

import StoreProducts from '../components/pages/store_products';
import TaxonAPI from '../apis/taxons';

import Actions from '../actions';
import translations from '../../translations/app-translations';

// TODO: This code(distinctProducts and fetchedProducts functions) is duplicate in base-product-list.js container. Clean and refactor
const distinctProducts = (products) => {
    const productsFilters = [];

    // eslint-disable-next-line no-restricted-syntax
    for (const product of products) {
        const filterCondition = productsFilters.findIndex((item) => item.id === product.id) === -1;
        if (filterCondition) {
            productsFilters.push(product);
        }
    }
    return productsFilters;
};

const fetchedProducts = (dispatch, locale) => dispatch(Actions.fetchProducts({ page_no: 1, locale })).then((response) => {
    const fetchedProducts = response.body;

    if (fetchedProducts.data.length === 0) {
        toastr.info(`${translations[locale]['no-products-found']}`);
    }

    dispatch(Actions.addProducts({ products: distinctProducts(fetchedProducts.data), meta: fetchedProducts.meta }));
    dispatch(Actions.hideLoader());
});

const mapStateToProps = (state, ownProps) => ({

});

const mapDispatchToProps = (dispatch) => ({

    loadStoresProducts: (locale, storeIdx) => {
        dispatch(Actions.displayLoader());

        // Load stores
        dispatch(Actions.fetchStores())
            .then((response) => {
                // TODO: Check if instead of selecting a default store it is better to show a `not-found`
                // find store for code
                const selectStore = response.find((store) => store.code === storeIdx) || response[0];

                // change current store value
                dispatch(Actions.setCurrentStore(selectStore));

                const taxonsMenu = [];

                // load store taxons
                TaxonAPI.getTaxons(selectStore.id)
                    .then((response) => {
                        const fetchedTaxons = response;
                        const taxonRoot = fetchedTaxons.filter((taxon) => taxon.parent_id === null)[0];
                        const taxonsCategory = fetchedTaxons.filter((taxon) => taxon.parent_id === taxonRoot.id);
                        const taxonCategorySubcategory = taxonsCategory
                            .map((taxonCategory) => ({
                                taxonCategory,
                                taxons: fetchedTaxons.filter((taxon) => taxon.parent_id === taxonCategory.id),
                            }));
                        taxonsMenu.push({ store: selectStore, taxonRoot, taxons: [...taxonCategorySubcategory] });

                        dispatch(Actions.addTaxons({ taxonsMenu, fetchedTaxons }));

                        // load products from selected store
                        fetchedProducts(dispatch, locale);
                    })
                    .catch((error) => {
                        // load products from selected store
                        fetchedProducts(dispatch, locale);
                    });
            });
    },
});

const StoreProductsConnector = connect(mapStateToProps, mapDispatchToProps)(StoreProducts);

export default BaseProductList(StoreProductsConnector);



/** WEBPACK FOOTER **
 ** ./src/containers/store-products-connector.js
 **/